module.exports = __webpack_public_path__ + "static/start_low_image_1-2d0731b2595101c2c7dc8ec82db1094c.png";